import { NgModule } from '@angular/core';
import { JpDateInputFormatDirective } from './directives/date-input-format-directive';

@NgModule({
    declarations: [JpDateInputFormatDirective],
    exports: [JpDateInputFormatDirective],
})
export class JpLangModule {}
